export default "__VITE_ASSET__BrYD4U8d__"